import IfpAppService from 'web-core/src/ifp-app-service';

export const RECEIVE_IFP_CROSS_SELL = 'RECEIVE_IFP_CROSS_SELL';

export const receiveIfpCrossSell = ifpCrossSell => (
  {
    type: RECEIVE_IFP_CROSS_SELL,
    ifpCrossSell,
  }
);

export const fetchCrossSellSource = appId => (
  (dispatch, getState, { apiClient }) => {
    const svc = new IfpAppService({ client: apiClient });

    return svc.getCrossSellSource(appId)
      .then((response) => {
        dispatch(receiveIfpCrossSell(response));
        return response;
      });
  }
);

export const postCrossSell = options => (
  (dispatch, getState, { apiClient }) => {
    const svc = new IfpAppService({ client: apiClient });

    return svc.postCrossSell(options)
      .then((response) => {
        dispatch(receiveIfpCrossSell(response));
        return response;
      });
  }
);
